import './index.scss';
import React, { useEffect, useState } from 'react';

function TextareaControl({structure, saveValue, defaultValue, runtimeValue}){

    const [controlValue, setControlValue] = useState(defaultValue ?? '');

    const handleChange = (e) => {
        let currentValue = e.currentTarget.value;
        setControlValue(currentValue);
        saveValue(currentValue);
    }

    // useEffect(()=>{
    //     setControlValue(defaultValue);
    // }, [defaultValue]);

    return (
        <div className="tbcourse-editor-control-textarea">
            <textarea
            className="form-control"
            rows="4"
            onChange={handleChange}
            placeholder={structure.placeholder}
            value={runtimeValue ?? controlValue}
            >
                {runtimeValue ?? controlValue}
            </textarea>
            <small className="form-text">{structure.helpText}</small>
        </div>
    );
}

export default TextareaControl;
